import React from "react";
import ActionBar from "../../common/ActionBar";
import CustomTable from "../../common/CustomTable/CustomTable";
import styled from "styled-components";
import CaseService from "../../../services/CaseService";
import queryString from "query-string";
import { useState } from "react";
import _ from "lodash";
import { useRef } from "react";
import { getFileName, parseTimeStamp } from "../../../helpers/functions";
import moment from "moment";
import labels from "../../../helpers/labels.json";
import { ArrowDownward, Description } from "@material-ui/icons";
import { Tooltip, IconButton } from "@material-ui/core";
import { CloseBtn } from "../../internal/BulkUpdate";
import { CustomInputField } from "../../common/FormInputs";
import { PrimaryCTAButton } from "../../common/Buttons";
import {
  ModalOverlay,
  ModalBox,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from "../../common/CaseDetails";
import { useSnackbar } from "notistack";

async function getUploads(query = "") {
  try {
    const response = await CaseService.bulkUpload(query);
    return { ...response };
  } catch (error) {
    return error;
  }
}

export default function BulkUploads() {
  const [state, setState] = useState();
  const MTRef = useRef();
  const [lotModal, setLotModal] = useState({
    open: false,
    row: null,
  });
  const [lotNumber, setLotNumber] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  async function assignLotToCase(payload) {
    try {
      const response = await CaseService.assignLotToCase(payload);
      if (response?.message) {
        enqueueSnackbar(response?.message, { variant: "success" });
      }
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: "error",
      });
    } finally {
      setLotNumber("");
      setLotModal({ open: false });
      MTRef.current.onQueryChange("");
    }
  }

  /*

  async function deleteuploadeFile(id) {
    try {
      setLoader({ state: true, message: "Delete uploade file..." });
      const response = await CaseService.deleteuploadeFile({
        id: id,
      });
      enqueueSnackbar(response?.message, {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      MTRef.current.onQueryChange("");
    }
  } 

  */

  const columns = [
    {
      field: "url",
      title: labels.file,
      sorting: false,
      render: (rowData) => decodeURI(getFileName(rowData.url)),
      headerStyle: {
        paddingLeft: "26px",
      },
      cellStyle: {
        paddingLeft: "26px",
        width: 250,
      },
    },
    {
      field: "lot",
      title: "Lot NO",
      sorting: false,
      render: (rowData) => {
        const fileUrl = rowData?.updatedFileWithCaseId;
        if (rowData?.lotNo) {
          return <span style={{ fontWeight: "600" }}>{rowData?.lotNo}</span>;
        }
        if (fileUrl) {
          return (
            <LotButton
              placeholder="Lot No"
              onClick={() => {
                setLotModal({ open: true, row: rowData });
                setLotNumber("");
              }}
              readOnly
            />
          );
        }
        return <span>-</span>;
      },
    },

    {
      field: "entity.name",
      title: labels.uploaded_for_party,
      sorting: false,
    },
    {
      field: "owner.name",
      title: labels.uploaded_by,
      sorting: false,
    },
    {
      field: "created_at",
      title: labels.uploaded_date,
      sorting: true,
      render: (rowData) =>
        moment(parseTimeStamp(rowData.created_at)).format("DD/MM/YYYY"),
      cellStyle: {
        width: 60,
      },
      headerStyle: {
        width: 60,
      },
    },
    {
      field: "updatedFileWithCaseId",
      title: "File with Case ID",
      sorting: false,
      render: (rowData) => {
        const fileUrl = rowData?.updatedFileWithCaseId;

        return (
          <Tooltip
            title={
              fileUrl ? "Download File with Case ID" : "File not available"
            }
          >
            <span>
              <IconButton
                size="small"
                disabled={!fileUrl}
                onClick={() => fileUrl && window.open(fileUrl, "_blank")}
                style={{
                  background: fileUrl ? "#f0f7ff" : "#f5f5f5",
                }}
              >
                {fileUrl ? (
                  <ArrowDownward style={{ color: "#00838c" }} />
                ) : (
                  <Description style={{ color: "#bdbdbd" }} />
                )}
              </IconButton>
            </span>
          </Tooltip>
        );
      },
      cellStyle: {
        width: 80,
        textAlign: "center",
      },
      headerStyle: {
        width: 80,
        textAlign: "center",
      },
    },
    {
      field: "action",
      title: "Download",
      sorting: false,
      render: (rowData) => (
        <Tooltip title="Download Original File">
          <IconButton
            size="small"
            onClick={() => window.open(rowData.url, "_blank")}
            style={{
              background: "#e8f5e9",
            }}
          >
            <ArrowDownward style={{ color: "#2e7d32" }} />
          </IconButton>
        </Tooltip>
      ),
      cellStyle: {
        width: 80,
        textAlign: "center",
      },
      headerStyle: {
        width: 80,
        textAlign: "center",
      },
    },
    /*
    {
      field: "actions",
      title: "",
      hidden: userObject?.isSuperCaseManager ? false : true,
      sorting: false,
      cellStyle: {
        width: 60,
      },
      headerStyle: {
        width: 60,
      },
      render: (rowData) => (
        <DeleteButtonContainer onClick={() => deleteuploadeFile(rowData.id)}>
          <DeleteIcon>✕</DeleteIcon>
        </DeleteButtonContainer>
      ),
    },
    */
  ];

  const data = (query) =>
    new Promise((resolve, reject) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
        query: query.search,
      };
      if (query.search) {
        params.search = query.search;
      }
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }
      getUploads(stringParams)
        .then((result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  return (
    <>
      <ActionBar
        breadcrumbs={[
          _.startCase(labels.cases),
          _.startCase(labels.bulk_uploads),
        ]}
      />
      <Padding>
        <CustomTable
          {...{
            data,
            state,
            MTRef,
            columns,
          }}
          hidePagination={state?.lastPage === 1}
          pageSize={state?.data?.length ? state?.data?.length : 10}
          singularTitle=""
          hideFilterBar={true}
          placeholderText={"Search"}
          // noToolbar
        />
      </Padding>
      {lotModal.open && (
        <ModalOverlay
          onClick={(e) =>
            e.target === e.currentTarget &&
            setLotModal({ open: false, row: null })
          }
        >
          <ModalBox onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>Enter Lot Number</ModalTitle>
              <CloseBtn onClick={() => setLotModal({ open: false })}>
                ✕
              </CloseBtn>
            </ModalHeader>
            <ModalBody>
              <CustomInputField
                variant="outlined"
                placeholder="Enter Lot Number"
                value={lotNumber}
                onChange={(e) => setLotNumber(e.target.value)}
              />
            </ModalBody>
            <ModalFooter>
              <PrimaryCTAButton
                type="button"
                style={{ width: "100px", padding: "10px 10px" }}
                disabled={!lotNumber}
                onClick={() => {
                  const lotNo = Number(lotNumber);
                  assignLotToCase({
                    batchId: lotModal.row?.id,
                    lotNo,
                  });
                }}
              >
                Update
              </PrimaryCTAButton>
            </ModalFooter>
          </ModalBox>
        </ModalOverlay>
      )}
    </>
  );
}

const Padding = styled.div`
  padding: 35px;
`;

const LotButton = styled.input`
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  background: #f8fafc;
  font-size: 13px;

  &:focus {
    outline: none;
    border-color: #00838c;
  }
`;
